import { getRandomInteger } from '@wareena/game-algorithms';
const doNothingStrategyFactory = (agentSide) => {
    return {
        name: 'doNothingStrategy',
        getMoveOrder: (gameState) => {
            const agentFreshUnits = gameState.units.filter((unit) => unit.side === agentSide && !unit.isFatigued);
            if (agentFreshUnits.length === 0) {
                return null;
            }
            const selectedIdx = agentFreshUnits.length > 1 ? getRandomInteger(0, agentFreshUnits.length - 1) : 0;
            return {
                agentUnit: agentFreshUnits[selectedIdx],
                targetPosition: null,
                pathToTargetPosition: null,
                targetEnemy: null,
            };
        },
    };
};
export default doNothingStrategyFactory;
